import script from "./index6.vue?vue&type=script&setup=true&lang=js"
export * from "./index6.vue?vue&type=script&setup=true&lang=js"

import "./index6.vue?vue&type=style&index=0&id=56480bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56480bbe"]])

export default __exports__